import { Property } from "./interfaces";

export const edadGestacional: Property = {
    title: "Edad Gestacional",
    type: "integer",
}